import React, { Fragment } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import i18n from "i18next";
import { useTranslation } from 'react-i18next';

import {introagp} from './imageLanguageHandler/introagp.js';
import {introday} from './imageLanguageHandler/introdaily.js';
import {introdaypenuser} from './imageLanguageHandler/introdaypenuser.js';
// import introinsulin from './images/introinsulin.jpg';

function Views() {
  const { t } = useTranslation('help');
  return (
    <Fragment>
      <h1 id="helpIntro">{t('Available views')}</h1>
      <small>{t('Estimated reading time')} 4 {t('minutes.')}</small>
      <p>
        {t('AvailableViews-IntroText')}
      </p>
      <section id="agp">
        <h2>{t('AGP Report')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('AvailableViews-AGPChapter1')}
        </p>
        <p>
          <ol>
            <li>
              <b>{t('AvailableViews-AGPList1Heading')}</b> {t('AvailableViews-AGPList1Text')}
            </li>
            <li>
              <b>{t('AvailableViews-AGPList2Heading')}</b> {t('AvailableViews-AGPList2Text')}
            </li>
            <li>
              <b>{t('AvailableViews-AGPList3Heading')}</b> {t('AvailableViews-AGPList3Text')}
            </li>
            <li>
              <b>{t('AvailableViews-AGPList4Heading')}</b> {t('AvailableViews-AGPList4Text')}
            </li>
          </ol>
        </p>
        <p>
          {t('AvailableViews-AGPChapter2')}
        </p>
        <p>
          <img 
            src={introagp[i18n.language]?.() || introagp['en']()}
            alt={t('AGP Report')}
          />
        </p>
      </section>
      {/*
      <section id="insulin">
        <h2>{t('Insulin view')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('AvailableViews-InsulinChapter1')}
        </p>
        <p>
          <ol>
            <li>
              <b>{t('AvailableViews-InsulinList1Heading')}</b> {t('AvailableViews-InsulinList1Text')}
            </li>
            <li>
              <b>{t('AvailableViews-InsulinList2Heading')}</b> {t('AvailableViews-InsulinList2Text')}
            </li>
            <li>
              <b>{t('AvailableViews-InsulinList3Heading')}</b> {t('AvailableViews-InsulinList3Text')}
            </li>
            <li>
              <b>{t('AvailableViews-InsulinList4Heading')}</b> {t('AvailableViews-InsulinList4Text')}
            </li>
            <li>
              <b>{t('AvailableViews-InsulinList5Heading')}</b> {t('AvailableViews-InsulinList5Text')}
            </li>
          </ol>
        </p>
        <p>
          {t('AvailableViews-InsulinChapter2')}
        </p>
        <p>
          <img src={introinsulin} alt={t('Insulin view')} />
        </p>
      </section>
      <section id="nutrition">
        <h3>{t('Nutrition view')}</h3>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
      </section>
      <section id="exercise">
        <h3>{t('Exercise view')}</h3>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
      </section>
      <section id="diary">
        <h3>{t('Diary view')}</h3>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
      </section> 
      */}
      <section id="day">
        <h2>{t('Daily view')}</h2>
        <p>
          <Link to="#toc">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('AvailableViews-DailyChapter1')}
        </p>
        <p>
          <ol>
            <li>
              <b>{t('AvailableViews-DailyList1Heading')}</b> {t('AvailableViews-DailyList1Text')}
            </li>
            <li>
              <b>{t('AvailableViews-DailyList2Heading')}</b> {t('AvailableViews-DailyList2Text')}
            </li>
            <li>
              <b>{t('AvailableViews-DailyList3Heading')}</b> {t('AvailableViews-DailyList3Text')}
            </li>
          </ol>
        </p>
        <p>
          {t('AvailableViews-DailyChapter2')}
        </p>
        <p>
          <img 
            src={introday[i18n.language]?.() || introday['en']()}
            alt={t('Daily view')} 
          />
        </p>
        <p>
          {t('AvailableViews-DailyPenUserChapter1')} 
        </p>
        <p>
          {t('AvailableViews-DailyPenUserChapter2')}
        </p>
        <p>
          <img 
            src= {introdaypenuser[i18n.language]?.() || introdaypenuser['en']()}
            alt={t('Daily view')}
          />
        </p>
        </section>
    </Fragment>
  );
}

export default Views;